import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import s from "./styles.scss";
import { CodigoEmpleado } from "../../../types/CodigoEmpleado";
import { formatEnum, formatIsoDate } from "../../helpers/formatters";

export interface TableProps {
  codigos: CodigoEmpleado[];
  handleCrearCodigo: (idUser) => void;
  handleEnviarComunicado: (idUser) => void;
  loading: boolean;
  idUser: any;
}

export const MemoTable = React.memo(
  ({
    codigos,
    handleCrearCodigo,
    handleEnviarComunicado,
    loading,
    idUser: idUserFilter
  }: TableProps) => {
    const [columns, setColumns] = useState(columnsFormatter());

    useEffect(() => {
      setColumns(columnsFormatter());
    }, []);

    const idUser =
      codigos && codigos.length > 0 ? codigos[0].idUser : idUserFilter;

    return (
      <>
        <div className="row">
          <div className="col-6 p-0">
            {!loading && idUser !== null && (
              <>
                <span
                  style={{ color: "#0078d4", cursor: "pointer" }}
                  onClick={() => handleCrearCodigo(idUser)}
                >
                  + Agregar código
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span
                  style={{ color: "#0078d4", cursor: "pointer" }}
                  onClick={() => handleEnviarComunicado(idUser)}
                >
                  ^ Enviar por correo
                </span>
              </>
            )}
            <span>&nbsp;</span>
          </div>
        </div>

        <div className="row mt-2">
          <div style={{ width: "100%" }}>
            <ReactTable
              data={codigos || []}
              columns={columns}
              loading={loading}
              defaultPageSize={10}
              className="-striped -highlight"
              showPagination={true}
              showPageSizeOptions={false}
              getTrProps={() => ({ style: { height: "30px" } })}
              sortable={false}
              previousText="Anterior"
              nextText="Siguiente"
              loadingText="Cargando..."
              noDataText="No se encontraron códigos"
              pageText="Página"
              ofText="de"
              rowsText="filas"
            />
          </div>
        </div>
      </>
    );
  }
);

function columnsFormatter() {
  return [
    {
      Header: "No. Emp.",
      id: "numeroEmpleado",
      headerClassName: "text-left",
      className: s.tdClear,
      width: 64,
      accessor: simpleAccessor("numeroEmpleado")
    },
    {
      Header: "Empleado",
      id: "empleado",
      headerClassName: "text-left",
      className: s.tdClear,
      width: 256,
      accessor: simpleAccessor("empleado")
    },
    {
      Header: "Código",
      id: "codigo",
      headerClassName: "text-left",
      className: s.tdClear,
      width: 64,
      accessor: simpleAccessor("codigo")
    },
    {
      Header: "Puesto de Trabajo",
      id: "puestos",
      headerClassName: "text-left",
      className: s.tdClear,
      width: 192,
      accessor: puestosAccessor()
    },
    {
      Header: "Membresía",
      id: "membresia",
      headerClassName: "text-left",
      className: s.tdClear,
      width: 128,
      accessor: membresiaAccessor()
    },
    {
      Header: "Fecha de Uso",
      id: "fechaRedencion",
      headerClassName: "text-left",
      className: s.tdClear,
      width: 128,
      accessor: fechaAccessor("fechaRedencion")
    },
    {
      Header: "Fecha de Baja",
      id: "fechaBaja",
      headerClassName: "text-left",
      className: s.tdClear,
      width: 128,
      accessor: fechaAccessor("fechaBaja")
    },
    {
      Header: "Motivo de Baja",
      id: "motivoBaja",
      headerClassName: "text-left",
      className: s.tdClear,
      accessor: motivoBajaAccessor()
    }
  ];
}

function simpleAccessor(key: keyof CodigoEmpleado) {
  return (row: CodigoEmpleado) => {
    return <div className={s.field}>{row[key]}&nbsp;</div>;
  };
}

function motivoBajaAccessor() {
  return (row: CodigoEmpleado) => {
    return <div className={s.field}>{formatEnum(row["motivoBaja"])}&nbsp;</div>;
  };
}

function membresiaAccessor() {
  return (row: CodigoEmpleado) => {
    const href = row.idMembresiaSocio
      ? `/membresias-socios/${row.idMembresiaSocio}?idClub=${row.idClubBase}&idPublico=${row.idPublico}`
      : "";
    const label = row.idMembresiaSocio
      ? `${row.idPublico} de ${row.clubBase}`
      : "";
    return href ? (
      <div className={s.field}>
        <a href={href} target="_blank" rel="noreferrer">
          {label}&nbsp;
        </a>
      </div>
    ) : (
      <div className={s.field}>&nbsp;</div>
    );
  };
}

function puestosAccessor() {
  return (row: CodigoEmpleado) => {
    if (!row.puestos || row.puestos.length === 0) {
      return <div className={s.field}>&nbsp;</div>;
    }
    const puestosStr = row.puestos.map(p => p.puesto).join(", ");
    return <div className={s.field}>{puestosStr}&nbsp;</div>;
  };
}

function fechaAccessor(key: "fechaRedencion" | "fechaBaja" | "fechaCreacion") {
  return (row: CodigoEmpleado) => {
    return <div className={s.field}>{formatIsoDate(row[key])}&nbsp;</div>;
  };
}
